import BaseNode from './BaseNode';
import BlockIcon from '@mui/icons-material/Block';
import { colors } from '../../styles';

const ViolationNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Violação" accent={colors.status.rejected} icon={<BlockIcon />} />
);

export default ViolationNode;
